import React from "react";
import { Text, View } from "native-base";
import { webFont } from "../../Universal/API/API";

type CartHeaderProps = {
  isSmallVersion: boolean;
  scaleAll: number;
  missingItemsCount: number;
  title?: string;
  orderId?: string;
  description?: string;
};

const CartHeader: React.FC<CartHeaderProps> = ({
  isSmallVersion,
  scaleAll,
  missingItemsCount,
  title = "Текущий заказ",
  orderId,
  description,
}) => {
  return (
    <View style={{ paddingTop: isSmallVersion ? 14 * scaleAll : 22 * scaleAll }}>
      <View style={{ marginBottom: 14 * scaleAll }}>
        <Text
          selectable={false}
          style={{
            fontFamily: webFont("Inter"),
            fontSize: isSmallVersion ? 22 * scaleAll : 28 * scaleAll,
            color: "#111111",
            fontWeight: "700",
            lineHeight: isSmallVersion ? 26 * scaleAll : 32 * scaleAll,
          }}
        >
          {title}
        </Text>

        {orderId ? (
          <Text
            selectable={false}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 13 * scaleAll,
              color: "#7A746C",
              fontWeight: "600",
              marginTop: 6 * scaleAll,
            }}
          >
            № {orderId}
          </Text>
        ) : null}

        {description ? (
          <Text
            selectable={false}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 13 * scaleAll,
              color: "#7A746C",
              fontWeight: "500",
              marginTop: 6 * scaleAll,
            }}
          >
            {description}
          </Text>
        ) : null}
      </View>

      {missingItemsCount > 0 ? (
        <View
          style={{
            borderRadius: 22 * scaleAll,
            backgroundColor: "#FFF9EF",
            borderWidth: 1,
            borderColor: "#F2E1B6",
            padding: 16 * scaleAll,
            marginBottom: 18 * scaleAll,
          }}
        >
          <Text
            selectable={false}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 13 * scaleAll,
              color: "#8A5B13",
              fontWeight: "600",
            }}
          >
            {missingItemsCount} поз. сейчас не найдены в каталоге и скрыты из списка корзины.
          </Text>
        </View>
      ) : null}
    </View>
  );
};

export default React.memo(CartHeader);
